var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"30px"}},[_c('el-alert',{attrs:{"closable":false,"title":"menu 1"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }